import { GatsbyImage } from "gatsby-plugin-image";
import React from 'react';
import Stars from '../../../centers/ratings/liststars';
import geIcon from '../../../../pages/images/genesislogomobile.png';
import styled from 'styled-components';

let gmdv = require(`../../../../ghc_config`);

const CardInfo = styled.div`
  // as a MBICard except for flex-direction
  margin: 5px;
  position: relative;
  display: flex;
  -webkit-flex-direction: center;
  flex-direction: center;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0,0,0,.125);
  border-radius: .25rem;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  border: 0;
  font-weight: 400;
  .cI-bullet {
    background-color: #ee1C25;
    background-image: url(${geIcon});
    background-size: 20px;
    background-repeat: no-repeat;
    background-position: center center;
    width: 28px;
    height: 28px;
    text-align: center;
    color: #e7e7e8 !important;
    border: 2px solid #d4d5d6;
    border-radius: 100%;
    order: 1;
  }
  .cI-content {
    display:block;
    width: 85%;
    margin-left: auto;
    order: 2;
    font-size: 0.8rem;
    .cI-title {
      font-size: 1.2em;
    }
    .gatsby-image-wrapper{
      display: inline-block;
      vertical-align: top;
    }
    .cI-mainC {
      width: 70%;
      float: right;
      font-size: 0.7rem;
      @media only screen and (max-width: 1200px) {
        width: 63%;
      }
      @media only screen and (max-width: 992px) {
        width: 100%;
      }
      @media only screen and (max-width: 760px) {
        width: 78%;     
      }
      @media only screen and (max-width: 500px) {
        width: 60%;     
      }
    }
    .cI-starsRating {
      background: url('/images/star-ratings-sprite.png') 0 0 repeat-x;
      width: 88px;
      height: 16px;
    }
    .cI-distance {
      font-weight: bolder;
    }
  }
`;

function InfoList(props) {

  let item = props.item
  let index = props.index
  let newlocations = props.newlocations

  let address_sl = `${item.node.field_city}, ${gmdv.selectState(item.node.field_state).spa} ${item.node.field_zip}`
  let distance = item.node.distance
  distance = Number((distance).toFixed(1))

  return (
    <CardInfo 
      before={index+1} 
      id={'place_'+index} 
      className="my-2 p-1 nano">
      <div className="cI-bullet"
        onClick={() => props.handleToggleOpen(item)} />   
      <a className="cI-content" 
        href={item.node.path.alias.toLowerCase()}
        target={(item.node.field_center_group === 1) ? `_blank` : `_self`}>
        <div className="cI-title black-text-Genesis">
        {item.node.title}</div>
        {newlocations[index].node.relationships.field_image_carousel[0] &&
        newlocations[index].node.relationships.field_image_carousel[0].localFile.childImageSharp &&
        <GatsbyImage 
        alt={item.node.title}
        image={newlocations[index].node.relationships.field_image_carousel[0].localFile.childImageSharp.list} />}
        <div className="cI-mainC">
          <div className="cI-address black-text-Genesis">
            <Stars 
              center={item.node.path.alias.toLowerCase()}
              allPracticemaxRatings={props.allPracticemaxRatings}/> 
            {item.node.field_address_fl}<br/>
            {address_sl}<br/>
            {distance != 0 ?
            <span className="cI-distance">
              <span className="black-text-Genesis">&gt;&gt;</span> {distance} miles
            </span>: null}
          </div>
        </div>
      </a>
    </CardInfo>
  )
}

export default InfoList;